module.exports = __webpack_public_path__ + "static/media/logo_v2.e2dc522c.png";